import * as ng from 'angular';
import { StSort } from './st-sort.directive';

export const StSortModule: string =
    ng.module('st-sort', [
    ])
        .directive('stSort', StSort)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-sort/st-sort.module.ts